import { ReactNode } from 'react';

import { Box, Grid, List, Typography } from '@mui/material';

import { IAccountHistoryItem } from '@clients/accountHistoryClient';
import AccountHistoryItem from '@components/accountHistory/accountHistoryBlock/AccountHistoryItem';

export type AccountHistoryBlockProps = {
    heading: ReactNode;
    items: IAccountHistoryItem[];
};

const AccountHistoryBlock = ({ heading, items }: AccountHistoryBlockProps) => {
    return (
        <Grid item xs={12} sx={{ mt: 3, mb: 3 }}>
            <Typography
                variant="overline"
                data-testid="account-history-block-typography">
                {heading}
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    width: '100%',
                }}>
                <List>
                    {items?.map((historyItem, index) => {
                        return (
                            <AccountHistoryItem
                                key={`history-item-${index}`}
                                testId={`history-item-${index}`}
                                item={historyItem}
                            />
                        );
                    })}
                </List>
            </Box>
        </Grid>
    );
};

export default AccountHistoryBlock;
